/**
 * Reducer for state.ui.modbio.complexPolymerVersionUIs
 */

import {BenchlingAction} from 'redux-stores/Action';

import {ComplexPolymerActionType} from './ComplexPolymerReduxActions';

interface ComplexPolymerVersionUIState {
  complexPolymerVersionId: string;
  isEditing: boolean;
}

export interface ComplexPolymerVersionUIsState {
  [complexPolymerId: string]: ComplexPolymerVersionUIState;
}

const COMPLEX_POLYMER_VERSION_UIS_INITIAL_STATE = {};

export function reduceComplexPolymerVersionUIs(
  state: ComplexPolymerVersionUIsState = COMPLEX_POLYMER_VERSION_UIS_INITIAL_STATE,
  action: BenchlingAction
): ComplexPolymerVersionUIsState {
  switch (action.type) {
    case ComplexPolymerActionType.MODBIO_UPDATE_COMPLEX_POLYMER_VERSION_ID: {
      return {
        ...state,
        [action.complexPolymerId]: {
          ...state[action.complexPolymerId],
          complexPolymerVersionId: action.complexPolymerVersionId,
        },
      };
    }
    case ComplexPolymerActionType.MODBIO_UPDATE_COMPLEX_POLYMER_EDITING_STATE: {
      return {
        ...state,
        [action.complexPolymerId]: {
          ...state[action.complexPolymerId],
          isEditing: action.isEditing,
        },
      };
    }
    default:
      return state;
  }
}
